import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { reduxKey } from './constants';
import { handleActions } from 'redux-actions';
import { initFlags, setFlags } from './actions';
import { addCalculatedFlags } from '../helpers';
const actionHandlers = handleActions({
    [initFlags.toString()]: (state, { payload: { flags } })=>addCalculatedFlags(flags),
    [setFlags.toString()]: (state, { payload: { flags } })=>addCalculatedFlags(_object_spread({}, state, flags))
}, {});
export default {
    [reduxKey]: actionHandlers
};
